

<template>
  <div class="view-modal position-relative">
    <div class="modal fade viewModalStats" id="viewModalStats" tabindex="-1" role="dialog" aria-labelledby="viewModal" aria-hidden="true">
      <div class="modal-dialog modal-lg custom-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="viewModalLabel"><b>Staff Available from {{getTime(hourData.current.time_from)}} EST - {{getTime(hourData.current.time_to)}} EST</b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
              <tr>
                <th>Name</th>
                <th class="text-center">Available Min</th>
                <th class="text-center">Heads Down Min</th>
                <th class="text-center">Stats</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in getStaff" :key="index">
                <td>
                  <img width="20px" class="rounded-circle mr-10" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">
                  {{ row.firstName }} {{row.lastName}}
                </td>
                <td class="text-center">
                  {{getAvailability(row)}}
                </td>
                <td class="text-center" width="25%"><span v-html="getOffDeskMin(row)"></span></td>
                <td class="text-center" width="25%"><span v-html="getStats(row.email)"></span></td>
              </tr>
              <tr v-for="(row, index) in afterShiftAvailableStaff" :key="index + 'undocument'">
                <td>
                  <img width="20px" class="rounded-circle mr-10" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.replier_email)}?s=50`">
                  {{ row.replier_name }}
                  <i data-toggle="tooltip" title="Refers to staff handling tickets outside shift hours" class="fa fa-star text-success make-cursor-pointer"></i>
                </td>
                <td class="text-center">
<!--                  {{getAvailability(row)}}-->
                </td>
                <td class="text-center" width="25%"></td>
                <td class="text-center" width="25%"><span v-html="getStats(row.replier_email)"></span></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button  type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import md5 from "crypto-js/md5";
import moment from "moment-timezone";
export default {
  data() {
    return {
      hourData: {
        current: {}
      }
    }
  },
  computed: {
    getStaff() {
      const arr = this.hourData.current.availableStaff|| []
      return arr.sort((a,b) => {
        const aVal = this.hourData.current.staff.find(el => el.replier_email === a.email);
        const bVal = this.hourData.current.staff.find(el => el.replier_email === b.email);
        const aCount = aVal ? (aVal.ticket_handled || 0) + (aVal.count_replies || 0) + (this.hourData.currentMonitorObj && this.hourData.currentMonitorObj.staff && !!this.hourData.currentMonitorObj.staff.find(el => el.email === a.email) ? this.hourData.currentMonitorObj.staff.find(el => el.email === a.email).count : 0): 0;
        const bCount = bVal ? (bVal.ticket_handled || 0) + (bVal.count_replies || 0) + (this.hourData.currentMonitorObj && this.hourData.currentMonitorObj.staff && !!this.hourData.currentMonitorObj.staff.find(el => el.email === b.email) ? this.hourData.currentMonitorObj.staff.find(el => el.email === b.email).count : 0) : 0;
        return bCount - aCount
      })
    },
    afterShiftAvailableStaff() {
      const arr = this.hourData.current ? this.hourData.current.staff || [] : []
      console.log('afterShiftAvailableStaff', arr)
      return arr ? arr.filter(el => !this.hourData.current.availableStaff.find(el1 => el1.email === el.replier_email)): [];
    }
  },
  methods: {
    getTime(time) {
      return moment.tz(time, 'America/Chicago').tz('America/New_York').format('HH:mm');
    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    getAvailability(row) {
      if(this.hourData.isLive) {
        const val = 15 - (this.getBreakMin(row, 'break') + this.getBreakMin(row, 'performance') + this.getBreakMin(row, 'meeting') + this.getBreakMin(row, 'other')+ this.getBreakMin(row, 'engineering'))
        return val > 0 ? val : 0;
      }
      const num = Number(row.availability)* 60;
      return num.toString().includes('.') ? num.toFixed(2) : num
    },
    getBreakMin(row, type) {
      const min = this.hourData.isLive ? 15 : 60
      const targetHour = this.getTime(this.hourData.current.time_from)
      const date = moment.tz(this.hourData.current.time_from, 'YYYY-MM-DD HH:mm', 'America/Chicago') // CT input
          .tz('America/New_York') // convert to ET
          .format('YYYY-MM-DD');
      console.log('targetHour', targetHour)
// Build time range in EST
      const hourStartEST = moment.tz(`${date} ${targetHour}`, "YYYY-MM-DD HH:mm", "America/New_York");
      const hourEndEST = hourStartEST.clone().add(min, "minutes").add(59, "seconds");
      let unavailable = 0
      if(!type || type === 'break') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (!el.type || el.type === 'break') && overlaps
        });
        if(breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            unavailable = unavailable + duration
          })
        }
      }else if(type === 'performance') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'performance') && overlaps
        });
        console.log('break array perf', breakArray, unavailable)
        if(breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      }else if(type === 'engineering') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'engineering') && overlaps
        });
        console.log('break array perf', breakArray, unavailable)
        if(breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      }else if(type === 'meeting') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'meeting') && overlaps
        });
        console.log('break array meeting', breakArray, unavailable)
        if(breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      }else if(type === 'other') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'other' || el.type === 'offSupport') && overlaps
        });
        console.log('break array other', breakArray, unavailable)
        if (breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      }
      return unavailable.toString().includes('.') ? unavailable.toFixed(2) : unavailable
    },
    getOffDeskMin(row) {
      let text = '';
      if(this.getBreakMin(row, 'performance') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'performance') > 0}">Performance <i class="fa fa-bolt text-warning"></i>: <span class="${this.getBreakMin(row, 'performance') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'performance')}</span></span><br>`;
      }if(this.getBreakMin(row, 'engineering') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'engineering') > 0}">Engineering <i style="color: saddlebrown" class="fa fa-laptop"></i>: <span class="${this.getBreakMin(row, 'engineering') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'engineering')}</span></span><br>`;
      }if(this.getBreakMin(row, 'break') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'break') > 0}">Break <i style="color: saddlebrown" class="fa fa-coffee"></i>: <span class="${this.getBreakMin(row, 'break') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'break')}</span></span><br>`;
      }if(this.getBreakMin(row, 'meeting') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'meeting') > 0}">Meeting <i style="color: grey" class="fa fa-headphones"></i>: <span class="${this.getBreakMin(row, 'meeting') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'meeting')}</span></span><br>`;
      }if(this.getBreakMin(row, 'other') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'other') > 0}">Other <i style="color: black" class="fa fa-wrench"></i>: <span class="${this.getBreakMin(row, 'other') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'other')}</span></span>`;
      }
      return text;
    },
    getStats(email, array) {
      let stats = '';
      const obj = this.hourData.current.staff.find(el => el.replier_email === email);
      console.log('obj at 73', obj, this.hourData.current)
      const className = !obj || obj.tickets_handled === 0 ? 'text-danger' : (obj && obj.tickets_handled >= 3 ? 'text-success' : 'text-warning')
      const replyClass = !obj || obj.count_replies === 0 ? 'text-danger' :( obj && obj.count_replies >= 3 ? 'text-success' : 'text-warning')
      stats += `<span class="fw-600">Tickets Handled: <span class="${className}">${obj ? obj.tickets_handled : 0}</span></span> <br>`
      stats += `<span class="fw-600">Count Replies: <span class="${replyClass}">${obj ? obj.count_replies : 0}</span> </span><br>`
      if(this.hourData.currentMonitorObj && this.hourData.currentMonitorObj.staff) {
        const emailObj = this.hourData.currentMonitorObj.staff.find(el => el.email === email);
        const monitor = !emailObj || emailObj.count === 0 ? 'text-danger' :( emailObj && emailObj.count >= 3 ? 'text-success' : 'text-warning')
        stats += `<span class="fw-600">Monitors Handled: <span class="${monitor}">${emailObj ? emailObj.count : 0}</span> </span>`
      } else {
        stats += `<span class="fw-600">Monitors Handled: <span>0</span> </span>`
      }
      return stats;
    },
    load(data){
      console.log('data received', data)
      if(data.isLive) {
        this.hourData.current = data.last15Min
      } else {
        this.hourData.current = data.hoursArray.find(el => el.time === data.time);
      }
      console.log('hour current', this.hourData.current)
      this.hourData.isLive = data.isLive;
      this.hourData.currentMonitorObj = data.currentMonitorObj;
      this.hourData.time = data.time;
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      $('#viewModalStats').modal('show');
    }
  }
}
</script>
<style scoped>
.modal-lg.custom-width {
  max-width: 900px; /* or whatever width you want */
}
</style>